import React, { useState } from "react";

// material import
import {
  Box,
  Button,
  Card,
  Divider,
  Grid,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";

// project import
import VisibilityIcon from "@mui/icons-material/Visibility";
import DashboardHeader from "../../ui-components/dashboardheader";
import CustomTable from "../../ui-components/customTable";
import PersonIcon from "@mui/icons-material/Person";
import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";
import LogoutIcon from "@mui/icons-material/Logout";
import PopUpModal from "../../ui-components/PopUpModal";
import UpdatePersonalDetails from "./updatePersonalDetails";
import UpdateBankDetails from "./updateBankDetails";
import LogOutConfirmation from "./logOutConfirmation";
import UpdateReservation from "./updateReservation";

const Index = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [isPersonalDetailsOpen, setIsPersonalDetailsOpen] = useState(false);
  const [isBankDetailsOpen, setIsBankDetailsOpen] = useState(false);
  const [isLogoutOpen, setIsLogoutOpen] = useState(false);
  const [isUpdateReservationOpen, setIsUpdateReservationOpen] = useState(false);

  const columns = [
    { label: "Date", field: "date" },
    { label: "Package", field: "package" },
    {
      label: "Receipt",
      field: "receipt",
      align: "center",
      renderCell: (row) => {
        return (
          <VisibilityIcon
            color="secondary"
            style={{ cursor: "pointer" }}
            onClick={() => alert(`View Receipt for ${row.package}`)}
          />
        );
      },
    },
  ];

  const rows = [
    {
      date: "2023-01-05",
      package: "Sponsor a Day",
    },
    {
      date: "2023-01-02",
      package: "One-Time Donation",
    },
  ];

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box>
      <DashboardHeader handleClick={handleClick} open={open} />
      <Grid container justifyContent="center">
        <Grid item xs={8.2}>
          <Typography variant="h5" sx={{ fontWeight: "medium", mb: 5, mt: 7 }}>
            My Reservation Details
          </Typography>
          <Box sx={{ mt: 5 }}>
            <Card>
              <Grid container spacing={1} p={5}>
                <Grid item xs={4} sx={{ borderRight: 1, borderColor: "gray" }}>
                  <Typography variant="h5" sx={{ fontSize: 18, color: "grey" }}>
                    Each month's
                  </Typography>
                  <Typography
                    variant="h4"
                    fontWeight="bold"
                    align="center"
                    mt={1}
                  >
                    01st
                  </Typography>
                </Grid>
                <Grid item xs={4} sx={{ borderRight: 1, borderColor: "gray" }}>
                  <Typography
                    variant="h5"
                    sx={{ fontSize: 18, color: "grey", ml: 2 }}
                  >
                    Next Donation Date
                  </Typography>
                  <Typography
                    variant="body1"
                    fontWeight="bold"
                    align="center"
                    mt={1}
                  >
                    01 February, 2025
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography
                    variant="h5"
                    sx={{ fontSize: 18, color: "grey", ml: 2 }}
                  >
                    Package
                  </Typography>
                  <Typography
                    variant="body1"
                    fontWeight="bold"
                    align="center"
                    mt={1}
                  >
                    Sponsor a Day
                  </Typography>
                  <Typography
                    variant="body1"
                    fontWeight="light"
                    align="center"
                    sx={{ fontSize: 13 }}
                  >
                    recurring (Monthly)
                  </Typography>
                </Grid>
              </Grid>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  mb: 2,
                  mr: 2,
                }}
              >
                <Button
                  variant="text"
                  sx={{ color: "#8B2757" }}
                  onClick={() => setIsUpdateReservationOpen(true)}
                >
                  Update
                </Button>
              </Box>
            </Card>
          </Box>
          <Typography variant="h5" sx={{ fontWeight: "medium", mb: 5, mt: 7 }}>
            Donation History
          </Typography>
          <Box sx={{ mt: 5 }}>
            <Card>
              <CustomTable columns={columns} rows={rows} />
            </Card>
          </Box>
        </Grid>
      </Grid>
      <Box>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem onClick={() => setIsPersonalDetailsOpen(true)}>
            <ListItemIcon>
              <PersonIcon color="primary" fontSize="small" />
            </ListItemIcon>
            Personal Details
          </MenuItem>
          <MenuItem onClick={() => setIsBankDetailsOpen(true)}>
            <ListItemIcon>
              <AssuredWorkloadIcon color="primary" fontSize="small" />
            </ListItemIcon>
            Payment Details
          </MenuItem>
          <Divider />
          <MenuItem onClick={() => setIsLogoutOpen(true)}>
            <ListItemIcon>
              <LogoutIcon color="error" fontSize="small" />
            </ListItemIcon>
            Logout
          </MenuItem>
        </Menu>
      </Box>

      <Box>
        <PopUpModal
          open={isPersonalDetailsOpen}
          handleCloseDialog={() => setIsPersonalDetailsOpen(false)}
          title="Update Personal Details"
          content={
            <UpdatePersonalDetails
              handleCloseDialog={() => setIsPersonalDetailsOpen(false)}
            />
          }
          maxWidth={700}
        />
      </Box>

      <Box>
        <PopUpModal
          open={isBankDetailsOpen}
          handleCloseDialog={() => setIsBankDetailsOpen(false)}
          title="Update Bank Details"
          content={
            <UpdateBankDetails
              handleCloseDialog={() => setIsBankDetailsOpen(false)}
            />
          }
          maxWidth={500}
        />
      </Box>

      <Box>
        <PopUpModal
          open={isUpdateReservationOpen}
          handleCloseDialog={() => setIsUpdateReservationOpen(false)}
          title="Update Reservation"
          content={
            <UpdateReservation
              handleCloseDialog={() => setIsUpdateReservationOpen(false)}
            />
          }
          maxWidth={500}
        />
      </Box>
    </Box>
  );
};

export default Index;
